import { action, makeAutoObservable, makeObservable, observable } from 'mobx'

import { contractController } from '@/controller/contract.controller'
import { DTO } from '@/dto/DTO'
import CheckableMap from '@/models/CheckableMap'
import { envUtils } from '@/utils/envUtils'

type StepContent<T = string> = {
  isDirty?: boolean
  isValid: boolean
  errorMessage: string
  content: T
}
type UsageTerm = {
  id: string
  value: string
  link: string
}
export class ContractModalService {
  uiStore = new UIStore()
  private readonly schoolflatHomepageUrl = envUtils.isLive
    ? 'https://www.schoolflat.com'
    : 'https://readable-arrow-509663.framer.app'
  // 이용동의
  usageTerms: StepContent<ReturnType<(typeof CheckableMap<string, UsageTerm>)['fromArr']>> = {
    isDirty: false,
    isValid: false,
    errorMessage: '모든 약관에 동의가 필요합니다.',
    content: CheckableMap.fromArr(
      [
        {
          id: 'service',
          value: '(필수) 이용약관',
          link: this.schoolflatHomepageUrl + '/terms_of_use',
        },
        {
          id: 'privacy',
          value: '(필수) 개인 정보 처리 방침',
          link: this.schoolflatHomepageUrl + '/privacy_policy',
        },
      ],
      'id',
    ),
  }
  // 계약서 확인
  viewPdfContract: Omit<StepContent, 'content'> = {
    isDirty: false,
    isValid: false,
    errorMessage: '계약서를 확인해주세요.',
  }
  // 서명
  schoolNameSignature: StepContent = {
    content: '',
    isValid: false,
    isDirty: false,
    errorMessage: '서명을 입력해주세요.',
  }
  teacherSignature: StepContent = {
    content: '',
    isValid: false,
    isDirty: false,
    errorMessage: '서명을 입력해주세요.',
  }

  constructor() {
    makeAutoObservable(this)
  }
  async downloadContractPdf() {
    return await contractController.downloadContractPdf()
  }
  setSchoolNameSignature(signature: string) {
    this.schoolNameSignature.content = signature
    this.schoolNameSignature.isValid = !!signature
    this.schoolNameSignature.isDirty = true
  }
  setTeacherSignature(signature: string) {
    this.teacherSignature.content = signature
    this.teacherSignature.isValid = !!signature
    this.teacherSignature.isDirty = true
  }
  async submitContract() {
    await contractController.submitContract({
      schoolNameSignature: this.schoolNameSignature.content,
      teacherSignature: this.teacherSignature.content,
    })
  }
}

class UIStore extends DTO {
  currentStep = 1
  contractPdfView = false
  constructor() {
    super()
    makeObservable(this, {
      goNextStep: action,
      goPrevStep: action,
      toggleContractView: action,
      currentStep: observable,
      contractPdfView: observable,
    })
  }
  goNextStep() {
    this.currentStep += 1
  }
  goPrevStep() {
    this.currentStep -= 1
  }
  toggleContractView() {
    this.contractPdfView = !this.contractPdfView
  }
}
